import request from '@/util/request';
import qs from 'qs';



export const getParkList = (params, options) =>
  request.get('/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode/v2?id=0', Object.assign({}, options, {
    params
  }));

  export const getRegionList = (params, options) =>
  request.get('/api/v4ward/car/ParkSpace/getRegionList/v2', Object.assign({}, options, {
    params
  }));


  export const nodeTreeByParentId = (parentId) => {
    return request({
      url: '/api/v4ward/car/parkSpaceNode/nodeTreeByParentId/v2',
      method: 'get',
      params: {
        parentId,
      },
    });
  };